enum BitePorterApplication {
  BureauProd = 'bureau',
  BureauSandbox = 'bureau-sandbox',
  BureauStaging = 'bureau-staging',
  ClockProd = 'clock',
  ClockSandbox = 'clock-sandbox',
  ClockStaging = 'clock-staging',
  FlashProd = 'flash',
  FlashSandbox = 'flash-sandbox',
  FlashStaging = 'flash-staging',
  GarconProd = 'garcon',
  GarconSandbox = 'garcon-sandbox',
  GarconStaging = 'garcon-staging',
  MaitredProd = 'maitred',
  MaitredSandbox = 'maitred-sandbox',
  MaitredStaging = 'maitred-staging',
  OrderProcessorProd = 'order-processor',
  OrderProcessorSandbox = 'order-processor-sandbox',
  OrderProcessorStaging = 'order-processor-staging',
  VitrineProd = 'vitrine',
  VitrineSandbox = 'vitrine-sandbox',
  VitrineStaging = 'vitrine-staging',
  WebhookReceiverProd = 'webhook-receiver',
  WebhookReceiverSandbox = 'webhook-receiver-sandbox',
  WebhookReceiverStaging = 'webhook-receiver-staging',
  RecommendationAppProd = 'recommendation',
  RecommendationAppStaging = 'recommendation-staging',
  RecommendationAppSandbox = 'recommendation-sandbox',
}

export { BitePorterApplication };
